import type { DataTableReactInstance } from "./table-features";

import { Trans } from "@lingui/react/macro";

import { NativeSelect } from "../../base/native-select";

const DEFAULT_OPTIONS = [10, 25, 50, 100];

export function RowsSelector<T>({
  table,
  options = DEFAULT_OPTIONS,
}: {
  table: DataTableReactInstance<T>;
  options?: number[];
}) {
  const pageSize = table.state.pagination.pageSize;

  return (
    <div className="pagination-rows">
      <label className="flex items-center gap-1">
        <Trans>Rows per page:</Trans>
        <NativeSelect
          className="w-auto"
          value={pageSize}
          onChange={(event) => {
            table.setPageSize(parseInt(event.target.value));
            table.setPageIndex(0);
          }}
        >
          {options.map((opt) => (
            <option key={opt}>{opt}</option>
          ))}
        </NativeSelect>
      </label>
    </div>
  );
}
